import React from "react";
import Footer from "./footer";

import Webconnection from "../web3";
import { detectAndSetWeb3 } from "../web3";
import { getWebcall } from "../web3";

import { imlovABI } from "../imlov";
import { imlovaddress } from "../imlov";
import { coopABI } from "../cooperator";
import { coopaddress } from "../cooperator";

let web3;

class Faqs extends React.Component {
  //state vars for web3
  state = { web3: null, accounts: null, imlov: null, cooperator: null };

  // var to show or not show menu
  sendDataToMenu = () => {
    const data = true;
    // Call the callback function passed from Menu
    this.props.onDataFromMenu(data);
  };

  //connect contracts via how ever web is connected
  async contracts() {
    const imlov = new this.state.web3.eth.Contract(imlovABI, imlovaddress);
    const cooperator = new this.state.web3.eth.Contract(coopABI, coopaddress);
    this.setState({ imlov });
    this.setState({ cooperator });
  }

  //connect metamask
  onConnectButton = async (event) => {
    const connect = await window.ethereum.request({ method: "eth_accounts" });

    if (connect.length === 0) {
      await getWebcall();
      web3 = await detectAndSetWeb3();
      this.setState({ web3 }, () => {
        // Callback function to insure state/contract before transact
        this.contracts();
      });
      const accounts = await web3.eth.getAccounts();
      this.setState({ accounts });
    }
  };

  // on load
  async componentDidMount() {
    //menu or not?
    this.sendDataToMenu();

    //title of page
    document.title = "Imperfect Lovers - FAQs and Glossary";

    //connect to web3 - either infura or metamasl
    if (!this.state.web3) {
      web3 = await detectAndSetWeb3();

      const accounts = await web3.eth.getAccounts();
      this.setState({ accounts });

      this.setState({ web3 }, () => {
        this.contracts();
      });
    }
  }

  render() {
    return (
      <div>
        <Webconnection />

        <header
          className="w3-display-container w3-content"
          style={{ maxWidth: "100%", minWidth: "500px", marginTop: "50px" }}
          id="home"
        >
          <a href="/">
            <img
              className="w3-image"
              src="./images/imperfect-lovers.png"
              alt="cropped Imperfect Lovers"
            />
          </a>
        </header>

        <div
          className="w3-right"
          style={{ width: "230px", marginRight: "5px", marginTop: "-5px" }}
        >
          {this.state.accounts != 0 && (
            <button
              type="button"
              disabled
              className="connect
      w3-button w3-light-grey w3-section"
            >
              connected: {this.state.accounts}
            </button>
          )}

          {this.state.accounts == 0 && (
            <button
              className="connect
      w3-button w3-light-grey w3-section"
              onClick={this.onConnectButton}
            >
              connect wallet
            </button>
          )}
        </div>

        <div className="w3-content">
          <div className="w3-padding-32" id="about">
            <div className="w3-padding-large">
              <h1>FAQs and Glossary</h1>

              <p>
                <i>Imperfect Lovers</i>, a finalist for the <a href="https://www.lumenprize.com/2024-finalists">Lumen Prize</a>,
                was inaugurated on February 23rd, 2024. I am currently working with curators, <a href="https://linktr.ee/haiverart">Haiver</a> and <a href="https://linktr.ee/speciesofvalue">Elisabeth Sweet</a>,  
                on an invitational exhibition, complete curators statement, and FAQs.
              </p>

              <p>

              The first three mints in this series - Imperfect Lovers, Lover 0, and Lover 1 - are dynamic and animated NFTs, which update with each trans-action. These are directly and continuously connected to their respective Smart Contracts, held/collected together and meant for institutional custodianship and exhibition. 

              All subsequent NFTs are static snapshots, Daily Displays &#8212; Portraits &#8212; freely available once per day.<br />&lt;<a href="https://opensea.io/collection/imperfect-lovers/overview" target="_blank" >
                  View on OpenSea
                  </a>&gt;
              </p>

              <h3 className="w3-text-blue-grey">
                Glossary of terms
              </h3> 

              <p style={{ maxWidth: "85%", marginLeft: "15px" }}>

              <b><i>Imperfect Lovers (2024)</i></b>: A continuous performance choreographed by Nathaniel Stern examining the nature of promises, balance, and productivity in a relationship between partners. <br /><br />

              <b><i>Re: Lovers</i></b>: The extension of Nathaniel Stern's <i>Imperfect Lovers (2024)</i>, which invites curated artists to engage with the artwork's conceptual dynamics.<br /><br />

              <b><i>Lover #0</i></b>: Smart contract engaged in a reciprocal, non-productive relationship with Contract #1.<br /><br />

              <b><i>Lover #1</i></b>: Smart contract engaged in a reciprocal, non-productive relationship with Contract #0.<br /><br />

              <b><i>Portraits</i></b>: Snapshots taken of the Lovers when someone calls for the image via smart contract trans-action<br /><br />

              <b><i>Co-Operator</i></b>: The smart contract which calculates the Lovers' daily transaction; prompts Lover #0 & Lover #1 to give to the other;  stores the historical values;  mints the portraits.<br /><br />

              <b><i>Balance</i></b>: The remaining reserves of each Lover to give; measured in ETH<br /><br />

              <b><i>Daily Gift</i></b>: Measured as a percentage of each Lover's most recent gift to the other<br /><br />

              <b><i>The Work</i></b>: The primary form of the Artist Couples' work, physical or otherwise<br /><br />

              <b><i>Daily Displays</i></b>: A gesture to <i>The Work</i> created by each Artist Couple, released online & minted daily for 1 month .



              </p>

              <h3 className="w3-text-blue-grey">
                The Artist
              </h3>
              <br />
              <img
                src="https://i0.wp.com/nathanielstern.com/newsite/wp-content/uploads/nathaniel-new-1.jpg?w=1920&ssl=1"
                width="75%"
              />
              <span
                className="w3-tag w3-light-grey w3-small w3-left-align w3-hide-small"
                style={{ width: "75%" }}
              >
                athaniel Stern in his studio.
              </span>
              <p>
                I have been making, teaching, and writing about digital art for
                more than 25 years. I like to work with technologies just as
                they hit the mainstream in a way where everyone is talking about
                them... but none of us truly understand them (yet). Here, I've
                flipped a libertarian and capitalist platform of crypto currency
                into a space for gifting and love.
              </p>
              <p>
                There's a long history to this work, and{" "}
                <a href="https://nathanielstern.art/">my work</a>, but one of
                the core predecessors (in addition to the FGT and On Kawara
                pieces I talk about in the artist statement) is my art work, {" "}
                <a href="https://nathanielstern.com/artwork/given-time/">
                  Given Time</a>, where two permanently logged-in Second Life avatars are each forever
                and only seen by and through the other. The video below, circa
                2013, gives more details.
              </p>
              <h3 className="w3-text-blue-grey">Given Time</h3><br />
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/deub5AMgblk?si=p2RuZUtVD9MkxpR6"
                allowFullScreen
              ></iframe>
              
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
export default Faqs;
